const COOKIE_NAME = "PCXT";
const COOKIE_REGEX = new RegExp(`(^| )${COOKIE_NAME}=([^;]+)`);
const SCRIPT_LOADED_EVENT = "PCXT-V3-ScriptLoaded";
const INITIALIZED_EVENT = "PCXT-V3-ModuleInitialized";
const CONTEXT_CHANGE_EVENT = "PCXT-V3-ContextChanged";
const COUPON_CHANGE_EVENT = "PCXT-V3-CouponCodeChanged";
const VAT_INCLUSIVITY_CHANGE_EVENT = "PCXT-V3-VatInclusivityChanged";
const DATE_TIME_CHANGE_EVENT = "PCXT-V3-EffectiveDateTimeChanged";
const VAT_INCLUSIVITY_QUERY_PARAMETER = "PCXTVATINCLUSIVE";
const DATE_TIME_QUERY_PARAMETER = "PCXTEFFECTIVEDATETIME";
const COOKIE_DATA = {
  COOKIE_NAME,
  COOKIE_REGEX
};
const QUERY_PARAMETERS = {
  VAT_INCLUSIVITY_QUERY_PARAMETER,
  DATE_TIME_QUERY_PARAMETER
};

export { CONTEXT_CHANGE_EVENT, COOKIE_DATA, COOKIE_NAME, COOKIE_REGEX, COUPON_CHANGE_EVENT, DATE_TIME_CHANGE_EVENT, DATE_TIME_QUERY_PARAMETER, INITIALIZED_EVENT, QUERY_PARAMETERS, SCRIPT_LOADED_EVENT, VAT_INCLUSIVITY_CHANGE_EVENT, VAT_INCLUSIVITY_QUERY_PARAMETER };
//# sourceMappingURL=shared-constants.js.map
